//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

// import created components  :

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

//MUI :
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Alert from '@mui/material/Alert';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

// API fetch
import axios from "axios";
import { baseURL } from '../../../config/api-config.js';

//data
import { openingHours, openingDates, intervalHoraires } from '../../../data/location-params'


//Translate utils :
import { translator } from "../../../utils/translator.js"
import parse from 'html-react-parser';

//import { useSelector, useDispatch } from "react-redux";
import { getLang, getLocation, getStepLocation } from "../../../store/selectors.js"; //global state : shopping state
import { locationSlice } from '../../../store/locationSlice.js';
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

//utils
import { heureDecimalConverter } from '../../../utils/dateTimeFunctions'
import { calculDuree, getDureeInfos } from '../../../utils/calcul-duree'


function PeriodeSelect() { // full page as component imported in router

    const dispatch = useDispatch();
    const lang = useSelector(getLang) //global state : shopping step
    const location = useSelector(getLocation) //global state : shopping step

    const [horaires, setHoraires] = useState([]);
    const [horairesLoc, setHorairesLoc] = useState([openingHours[0], openingHours[1]]);

    useEffect(() => {

        let newList = [];
        for (let i = openingHours[0]; i <= openingHours[1]; i = i + intervalHoraires) {
            newList.push(i);
        }
        setHoraires(newList);

    }, [])

    useEffect(() => {

        for (let i = 0; i < 2; i++) {
            if (dayjs().isSame(dayjs(location["d" + String(i)]), "day") && location["h" + String(i)] < dayjs().hour()) {
                dispatch(locationSlice.actions.modifLocation([
                    { champ: "h" + String(i), value: dayjs().hour() }
                ]))
            }
        }
    }, [horairesLoc])

    useEffect(() => {
        setHorairesLoc([location.h1, location.h2]);
        console.log("modif location", location.d1, location.d2)
    }, [location])



    function setDate(date, index) {

        let listChamps = [];

        if (index === 1 && dayjs(date).isAfter(dayjs(location.d2), 'day')) {
            listChamps.push({ champ: "d1", value: dayjs(date).format("YYYY-MM-DD") });
            listChamps.push({ champ: "d2", value: dayjs(date).format("YYYY-MM-DD") });

        } else {
            listChamps.push(
                { champ: "d" + String(index), value: dayjs(date).format("YYYY-MM-DD") }
            )

        }
        dispatch(locationSlice.actions.modifLocation(listChamps))
    }

    function getMinDate() {

        if (dayjs().isAfter(dayjs(String(dayjs().year()) + "-" + openingDates[0]), 'day')) {
            return dayjs()
        } else {
            return dayjs(String(dayjs().year()) + "-" + openingDates[0])
        }
    }

    function changeHoraire(horaire, index) {

        dispatch(locationSlice.actions.modifLocation([
            { champ: "h" + String(index), value: horaire }
        ]))

    }




    return (
        <div className="location-periode">
            <div className="location-periode-selection">

                <div className="location-periode-selection-date1">
                    <p>{translator("du : ", lang, "DatePickFrom")}</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
                        <DatePicker
                            sx={{
                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { border: '1px solid #34B0EE' },                               // at page load
                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: '2px solid #362782' },  // at hover state
                            }}
                            className="location-periode-selection-datepicker"
                            label={translator("Choisissez une date", lang, "weekPick")}
                            size="small"
                            value={dayjs(location.d1)}
                            onChange={(newValue) => setDate(dayjs(newValue), 1)}
                            minDate={getMinDate()}
                            maxDate={dayjs(String(dayjs().year()) + "-" + openingDates[1])}

                        /* 
                        onChange={(newValue) => setDateRef(dayjs(newValue))} */
                        // className='calendar-header-date-picker'
                        />
                    </LocalizationProvider>
                    <p>{translator("à : ", lang, "DatePickAt")} </p>
                    <FormControl>
                        <InputLabel id="demo-simple-select-label">Horaire</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            className="location-periode-selection-timepicker"
                            id="demo-simple-select"
                            label="Horaire"
                            value={horairesLoc[0]}
                            onChange={e => changeHoraire(e.target.value, 1)}
                        >{
                                horaires.map(horaire => (
                                    <MenuItem key={horaire} disabled={dayjs(location.d1).isAfter(dayjs(), "day") ? dayjs(location.d1).isSame(dayjs(location.d2), "day") ? horaire > horairesLoc[1] : false : horaire < dayjs().hour()} value={horaire}>{heureDecimalConverter(horaire)}</MenuItem>

                                ))
                            }

                        </Select>
                    </FormControl>

                </div>
                <div className="location-periode-selection-date2">
                    <p>{translator("au : ", lang, "DatePickTo")} </p>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
                        <DatePicker
                            sx={{
                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { border: '1px solid #34B0EE' },                               // at page load
                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: '2px solid #362782' },  // at hover state
                            }}
                            className="location-periode-selection-datepicker"
                            label={translator("Choisissez une date", lang, "weekPick")}
                            size="small"
                            value={dayjs(location.d2)}
                            minDate={dayjs(location.d1)}
                            maxDate={dayjs(String(dayjs().year()) + "-" + openingDates[1])}
                            onChange={(newValue) => setDate(dayjs(newValue), 2)}
                        /* 
                        // className='calendar-header-date-picker'
                        */
                        />
                    </LocalizationProvider>
                    <p>{translator("à : ", lang, "DatePickAt")} </p>
                    <FormControl>
                        <InputLabel id="demo-simple-select-label">Horaire</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            className="location-periode-selection-timepicker"
                            id="demo-simple-select"
                            label="Horaire"
                            value={horairesLoc[1]}
                            onChange={e => changeHoraire(e.target.value, 2)}
                        >{
                                horaires.map(horaire => (
                                    <MenuItem key={horaire} disabled={dayjs(location.d2).isSame(dayjs(location.d1), "day") ? horaire < horairesLoc[0] : false} value={horaire}>{heureDecimalConverter(horaire)}</MenuItem>

                                ))
                            }

                        </Select>
                    </FormControl>


                </div>

            </div>

            <div className="location-periode-recap">
                <p>{translator("Soit", lang, "DureeEquals")} {getDureeInfos(calculDuree(location))}</p>

            </div>

        </div>



    );
}

export default PeriodeSelect;